exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.features-panel li{line-height:24px\n}", ""]);

// exports
